import React from "react";

const TableRowCheckBox = (props) => {
    if (!props.isCurrentUser) {
        return (
            <div className="checkbox-container">
                <input type="checkbox" id={props.id}
                    checked={props.isChecked} value={props.id}
                    onClick={() => props.setCheckbox(props.id)}></input>
                <label htmlFor={props.id}>{props.nombre}</label>
            </div>
        )
    } else {
        return null;
    }
}

export default TableRowCheckBox;